/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, OrganisationListEntryFromJSON, OrganisationListEntryToJSON, UserSessionFromJSON, UserSessionToJSON, } from './';
export function UserResponseFromJSON(json) {
    return UserResponseFromJSONTyped(json, false);
}
export function UserResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'orphan': !exists(json, 'orphan') ? undefined : json['orphan'],
        'sessions': !exists(json, 'sessions') ? undefined : (json['sessions'].map(UserSessionFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'organisation': !exists(json, 'organisation') ? undefined : OrganisationListEntryFromJSON(json['organisation'])
    };
}
export function UserResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'username': value.username,
        'lastName': value.lastName,
        'email': value.email,
        'active': value.active,
        'orphan': value.orphan,
        'sessions': value.sessions === undefined ? undefined : (value.sessions.map(UserSessionToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'firstName': value.firstName,
        'organisation': OrganisationListEntryToJSON(value.organisation)
    };
}
